<template>
    <div>
        <h4 v-translate>Your custom categories</h4>
        <div class="help-block" v-show="showHint">
            <p v-translate>
                These cost types will be seen by all your customers and they will be able to book their receipts on these entries.
                If you want to hide cost types, archive them. If you want to manage cost types per customer,
                you have to go to your customers local account.
            </p>
        </div>
        <div class="setting-content--section mb-4">
            <CostTypeTable flag="custom" @costTypeCreated="onCostTypeCreated" @costTypeUpdated="onCostTypeUpdated" />
        </div>
        <h4 class="mb-2" v-translate>Default categories</h4>
        <div class="setting-content--section">
            <CostTypeTable flag="default" />
        </div>
    </div>
</template>

<script>
import UserService from "@/store/services/user.service.js";
import ProfileService from "@/store/services/profile.service.js";
import CostTypeTable from "@/components/cost_types/CostTypeTable.vue";

// mixins
import settingsPageSetup from "@/mixins/settingsPageSetup";

export default {
    name: "CostTypesSettings",
    components: {
        CostTypeTable
    },
    mixins: [settingsPageSetup],
    data() {
        return {
            showHint: false,
            pageSettings: {
                title: this.$gettext("Company cost categories"),
                showCompanyPicker: true
            },
            form: {
                profile: {}
            },
            user: {},
            showDismissibleAlert: false,
        }
    },
    created(){
        var vm = this;
        UserService.retrieveCurrent({extended: 'True'}).then(function(response){
            vm.user = response.data;
        });
        ProfileService.list({user: window.user_id}).then(function (response) {
            vm.form.profile = response.data[0];
        })
    },
    methods: {
        onSubmit(evt) {
            var vm = this;
            evt.preventDefault();
            delete this.form.profile.avatar;
            delete this.form.profile.avatar_thumb;
            ProfileService.update(this.form.profile.id, this.form.profile).then(function(){
                vm.showDismissibleAlert = true;
            })
        },
        onCostTypeCreated(val) {
            this.$emit("costTypeCreated", val);
        },
        onCostTypeUpdated(val) {
            this.$emit("costTypeUpdated", val);
        }
    }
};
</script>
<style >

</style>
